export default __webpack_public_path__ + "assets/images/ff2932004983ff41cca617ce8bdca8c7.svg";